import {ApiClient} from '@hconnect/apiclient'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {
  type ChecklistDoneForTemplateDto,
  SortOrder,
  type PagedResponse,
  HrocChecklistsQueryKey
} from '../../types'

type ChecklistDoneForTemplateParams = {
  plantId: string
  templateId: string
  page?: number
  rowsPerPage?: number
  sortOrder?: SortOrder
}

type QueryOptions = Omit<
  UseQueryOptions<PagedResponse<ChecklistDoneForTemplateDto>, AxiosError>,
  'queryKey' | 'queryFn'
>

export const useChecklistDoneForTemplate = (
  {
    plantId,
    templateId,
    page = 0,
    rowsPerPage = 10,
    sortOrder = SortOrder.DESCENDING
  }: ChecklistDoneForTemplateParams,
  options?: QueryOptions
) => {
  const offset = page * rowsPerPage
  const limit = rowsPerPage
  const path = `/hroc-checklists/api/${plantId}/checklists/done-for-template/${templateId}`

  return useQuery<PagedResponse<ChecklistDoneForTemplateDto>, AxiosError>({
    queryKey: [
      HrocChecklistsQueryKey.ChecklistDoneForTemplate,
      plantId,
      templateId,
      offset,
      limit,
      sortOrder
    ],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<
        PagedResponse<ChecklistDoneForTemplateDto>
      >(path, {
        params: {offset, limit, sortOrder},
        signal
      })
      return response.data
    },
    placeholderData: (prev) => prev,
    ...options
  })
}
